var map = {
	"./alert/balance.png": 1693,
	"./alert/bg-balance.png": 7067,
	"./alert/learning.png": 6979,
	"./alert/profile-bg.png": 3468,
	"./alert/social.png": 3412,
	"./avatar/1.jpg": 9215,
	"./avatar/10.jpg": 9999,
	"./avatar/11.jpg": 2,
	"./avatar/12.jpg": 2141,
	"./avatar/13.jpg": 5040,
	"./avatar/2.jpg": 2576,
	"./avatar/3.jpg": 8141,
	"./avatar/4.jpg": 1270,
	"./avatar/5.jpg": 2883,
	"./avatar/6.jpg": 2836,
	"./avatar/7.jpg": 881,
	"./avatar/8.jpg": 3530,
	"./avatar/9.jpg": 4695,
	"./banner/1.jpg": 226,
	"./banner/2.jpg": 6157,
	"./banner/3.jpg": 3936,
	"./big-lightgallery/1.jpg": 8989,
	"./big-lightgallery/10.jpg": 1905,
	"./big-lightgallery/11.jpg": 3860,
	"./big-lightgallery/12.jpg": 5491,
	"./big-lightgallery/2.jpg": 3058,
	"./big-lightgallery/3.jpg": 4767,
	"./big-lightgallery/4.jpg": 6980,
	"./big-lightgallery/5.jpg": 1313,
	"./big-lightgallery/6.jpg": 3558,
	"./big-lightgallery/7.jpg": 3043,
	"./big-lightgallery/8.jpg": 8584,
	"./big-lightgallery/9.jpg": 6453,
	"./big-masonry/1.jpg": 1302,
	"./big-masonry/10.jpg": 4764,
	"./big-masonry/11.jpg": 1641,
	"./big-masonry/12.jpg": 1374,
	"./big-masonry/13.jpg": 9419,
	"./big-masonry/14.jpg": 6328,
	"./big-masonry/15.jpg": 6997,
	"./big-masonry/2.jpg": 9073,
	"./big-masonry/3.jpg": 548,
	"./big-masonry/4.jpg": 2511,
	"./big-masonry/5.jpg": 6162,
	"./big-masonry/6.jpg": 4653,
	"./big-masonry/7.jpg": 1200,
	"./big-masonry/8.jpg": 6107,
	"./big-masonry/9.jpg": 9646,
	"./blog/blog-2.jpg": 8052,
	"./blog/blog-3.jpg": 8001,
	"./blog/blog-5.jpg": 783,
	"./blog/blog-6.jpg": 464,
	"./blog/blog-single.jpg": 6240,
	"./blog/blog.jpg": 6617,
	"./blog/img.png": 4044,
	"./checkout/paypal.png": 2204,
	"./customizer/dark.png": 1446,
	"./customizer/light.png": 5480,
	"./customizer/mix.png": 7606,
	"./dashboard1/1.gif": 8378,
	"./dashboard1/bg.png": 5643,
	"./dashboard1/invest/01.jpg": 7363,
	"./dashboard1/invest/02.jpg": 7316,
	"./dashboard1/invest/03.jpg": 5361,
	"./dashboard1/invest/04.jpg": 3666,
	"./dashboard2/7.png": 9468,
	"./dashboard2/9.png": 4178,
	"./dashboard2/delivery.png": 5723,
	"./dashboard2/headphone.png": 5381,
	"./dashboard2/order/bench.png": 3528,
	"./dashboard2/order/flower.png": 8721,
	"./dashboard2/order/shoes.png": 3178,
	"./dashboard2/order/watch.png": 8603,
	"./dashboard2/product/1.png": 4706,
	"./dashboard2/product/2.png": 8713,
	"./dashboard2/product/3.png": 2960,
	"./dashboard2/product/4.png": 8831,
	"./dashboard2/product/headphones.png": 8530,
	"./details_close.png": 3441,
	"./details_open.png": 2005,
	"./ecommerce/01.jpg": 7782,
	"./ecommerce/02.jpg": 7393,
	"./ecommerce/03.jpg": 9348,
	"./ecommerce/04.jpg": 5727,
	"./ecommerce/05.jpg": 9346,
	"./ecommerce/06.jpg": 8301,
	"./ecommerce/07.jpg": 9088,
	"./ecommerce/08.jpg": 1867,
	"./ecommerce/banner.jpg": 689,
	"./ecommerce/card.png": 6633,
	"./ecommerce/mastercard.png": 9007,
	"./ecommerce/paypal.png": 6894,
	"./ecommerce/product-table-1.png": 919,
	"./ecommerce/product-table-2.png": 6988,
	"./ecommerce/product-table-3.png": 2901,
	"./ecommerce/product-table-4.png": 2474,
	"./ecommerce/product-table-5.png": 4387,
	"./ecommerce/product-table-6.png": 8776,
	"./ecommerce/product-table-7.png": 9905,
	"./ecommerce/visa.png": 884,
	"./email-template/1.jpg": 2235,
	"./email-template/1.png": 7171,
	"./email-template/10.jpg": 9955,
	"./email-template/11.jpg": 6790,
	"./email-template/12.jpg": 6369,
	"./email-template/2.png": 1416,
	"./email-template/3.png": 2545,
	"./email-template/4.png": 4830,
	"./email-template/5.png": 4055,
	"./email-template/6.png": 5948,
	"./email-template/7.jpg": 9813,
	"./email-template/7.png": 8837,
	"./email-template/8.jpg": 2998,
	"./email-template/8.png": 4306,
	"./email-template/banner-2.jpg": 8104,
	"./email-template/banner.jpg": 7838,
	"./email-template/cosmetic.jpg": 2949,
	"./email-template/delivery-2.png": 1997,
	"./email-template/delivery.png": 3000,
	"./email-template/invoice-1/1.png": 1457,
	"./email-template/invoice-1/sign.png": 5249,
	"./email-template/invoice-3/bg-0.png": 4498,
	"./email-template/invoice-3/bg.png": 3262,
	"./email-template/invoice-3/sign.png": 1007,
	"./email-template/pdfs.png": 7921,
	"./email-template/slider.jpg": 2123,
	"./email-template/space.jpg": 6844,
	"./email-template/success.png": 6343,
	"./email/1.jpg": 6986,
	"./email/2.jpg": 4213,
	"./email/3.jpg": 6600,
	"./faq/1.jpg": 8398,
	"./faq/2.jpg": 7993,
	"./faq/3.jpg": 2732,
	"./faq/4.jpg": 2695,
	"./faq/learning-1.png": 3111,
	"./favicon/Truesales.png": 183,
	"./favicon/android-chrome-192x192.png": 2660,
	"./favicon/android-chrome-512x512.png": 3068,
	"./favicon/apple-touch-icon.png": 91,
	"./favicon/favicon-16x16.png": 4406,
	"./favicon/favicon-32x32.png": 7930,
	"./favicon/favicon-96x96.png": 550,
	"./favicon/favicon.ico": 9070,
	"./favicon/site.webmanifest": 1731,
	"./file-manager/folder.png": 5689,
	"./file-manager/folder1.png": 1460,
	"./forms/Bank-of-Baroda.png": 6326,
	"./forms/SCB.png": 9986,
	"./forms/authenticate.png": 9159,
	"./forms/axis.png": 5287,
	"./forms/credit-card.png": 4396,
	"./forms/delivery.png": 3660,
	"./forms/email.png": 9582,
	"./forms/flags.png": 6287,
	"./forms/hdfc.png": 9493,
	"./forms/idbi.png": 3588,
	"./forms/qr-code.png": 7199,
	"./forms/qr-scan.png": 3859,
	"./forms/rbl.png": 66,
	"./forms/us-bank.png": 3245,
	"./forms/user.png": 2157,
	"./gif/danger.gif": 2467,
	"./gif/dashboard-8/successful.gif": 3378,
	"./gif/facebook.gif": 9202,
	"./gif/instagram.gif": 3462,
	"./gif/logout.gif": 2496,
	"./gif/new.gif": 3664,
	"./gif/online-shopping.gif": 8196,
	"./gif/successful.gif": 764,
	"./gif/whatapp.gif": 381,
	"./img-cropper1.jpg": 9242,
	"./job-search/1.jpg": 2718,
	"./job-search/2.jpg": 7865,
	"./job-search/3.jpg": 76,
	"./job-search/4.jpg": 311,
	"./job-search/5.jpg": 5997,
	"./job-search/6.jpg": 5605,
	"./js-grid.png": 7340,
	"./knowledgebase/bg_1.jpg": 8655,
	"./landing/homebg.png": 1592,
	"./lightgallery/1.jpg": 1574,
	"./lightgallery/10.jpg": 687,
	"./lightgallery/11.jpg": 4793,
	"./lightgallery/12.jpg": 4734,
	"./lightgallery/2.jpg": 1185,
	"./lightgallery/3.jpg": 3140,
	"./lightgallery/4.jpg": 9519,
	"./lightgallery/5.jpg": 9490,
	"./lightgallery/6.jpg": 8445,
	"./lightgallery/7.jpg": 2880,
	"./lightgallery/8.jpg": 5659,
	"./lightgallery/9.jpg": 702,
	"./login/1.jpg": 8750,
	"./login/2.jpg": 4166,
	"./login/3.jpg": 4275,
	"./login/icon.png": 4378,
	"./login/login_bg.jpg": 7665,
	"./login/login_bg.png": 3385,
	"./logo/TrueSalesPharmalogo.png": 8138,
	"./logo/Truesales.png": 3580,
	"./logo/dark-login-logo.png": 1478,
	"./logo/dark-logo.png": 1772,
	"./logo/landing-logo.png": 1925,
	"./logo/logo-login.png": 1691,
	"./logo/logo.png": 6447,
	"./masonry/1.jpg": 1419,
	"./masonry/10.jpg": 4739,
	"./masonry/11.jpg": 3126,
	"./masonry/12.jpg": 2737,
	"./masonry/13.jpg": 4692,
	"./masonry/14.jpg": 7423,
	"./masonry/15.jpg": 1042,
	"./masonry/2.jpg": 6252,
	"./masonry/3.jpg": 601,
	"./masonry/4.jpg": 8506,
	"./masonry/5.jpg": 663,
	"./masonry/6.jpg": 7816,
	"./masonry/7.jpg": 8997,
	"./masonry/8.jpg": 2790,
	"./masonry/9.jpg": 1315,
	"./other-images/bg-profile.png": 3887,
	"./other-images/boxbg.jpg": 138,
	"./other-images/coming-soon-bg.jpg": 1823,
	"./other-images/emoji/angry.png": 1884,
	"./other-images/emoji/love.png": 8747,
	"./other-images/emoji/sad.png": 655,
	"./other-images/emoji/smile.png": 2847,
	"./other-images/emoji/think.png": 6027,
	"./other-images/error400.svg": 784,
	"./other-images/error401.svg": 6321,
	"./other-images/error403.svg": 7827,
	"./other-images/error404.svg": 7644,
	"./other-images/error500.svg": 8041,
	"./other-images/error503.svg": 3018,
	"./other-images/img-1.jpg": 4735,
	"./other-images/img-2.jpg": 4416,
	"./other-images/img-3.jpg": 2509,
	"./other-images/img-4.jpg": 6166,
	"./other-images/img-cropper.jpg": 8697,
	"./other-images/invoice.svg": 8411,
	"./other-images/maintenance-bg.jpg": 8465,
	"./other-images/mountain.jpg": 9279,
	"./other-images/paypal.png": 3687,
	"./other-images/profile-style-img.png": 461,
	"./other-images/profile-style-img3.png": 4466,
	"./other-images/sea.jpg": 2389,
	"./other-images/sidebar-bg.jpg": 2270,
	"./product/1.png": 2983,
	"./product/10.png": 4167,
	"./product/11.png": 6478,
	"./product/12.png": 2229,
	"./product/13.png": 5692,
	"./product/14.png": 9507,
	"./product/15.png": 4282,
	"./product/2.png": 2924,
	"./product/3.png": 2021,
	"./product/4.png": 5514,
	"./profile.png": 7173,
	"./scrollbar/fashion1.jpg": 7160,
	"./scrollbar/fashion2.jpg": 1911,
	"./scrollbar/fashion3.jpg": 8074,
	"./scrollbar/fashion4.jpg": 8761,
	"./scrollbar/fashion5.jpg": 716,
	"./scrollbar/fashion6.jpg": 3515,
	"./search-not-found.png": 5379,
	"./slider/1.jpg": 1719,
	"./slider/10.jpg": 5639,
	"./slider/11.jpg": 9802,
	"./slider/2.jpg": 2792,
	"./slider/3.jpg": 53,
	"./slider/4.jpg": 9166,
	"./slider/5.jpg": 5627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 5682,
	"./slider/9.jpg": 5679,
	"./social-app/post-1.png": 924,
	"./social-app/post-2.png": 9031,
	"./social-app/post-3.png": 3454,
	"./social-app/post-4.png": 1169,
	"./social-app/post-5.png": 40,
	"./social-app/post-6.png": 5795,
	"./social-app/post-7.png": 586,
	"./social-app/post-8.png": 3533,
	"./social-app/post-9.png": 500,
	"./social-app/social-image.png": 8709,
	"./social-app/timeline-1.png": 1763,
	"./social-app/timeline-2.png": 9800,
	"./social-app/timeline-3.png": 929,
	"./social-app/timeline-4.png": 2446,
	"./social/1.png": 9977,
	"./social/2.png": 5970,
	"./social/3.png": 9627,
	"./social/4.png": 7636,
	"./sort_asc.png": 850,
	"./sort_asc_disabled.png": 9895,
	"./sort_both.png": 3740,
	"./sort_desc.png": 5278,
	"./sort_desc_disabled.png": 979,
	"./start-conversion.jpg": 1037,
	"./switch/1.jpg": 2360,
	"./switch/2.jpg": 9639,
	"./switch/3.jpg": 2122,
	"./switch/4.jpg": 8585,
	"./switch/5.jpg": 3324,
	"./switch/6.jpg": 3947,
	"./switch/7.jpg": 8990,
	"./switch/8.jpg": 6733,
	"./switch/square-gray.png": 6710,
	"./switch/square.svg": 6044,
	"./user/1.jpg": 5585,
	"./user/10.jpg": 7341,
	"./user/11.jpg": 8768,
	"./user/12.jpg": 3119,
	"./user/13.jpg": 1410,
	"./user/14.jpg": 9665,
	"./user/15.jpg": 5332,
	"./user/2.jpg": 3382,
	"./user/3.jpg": 3491,
	"./user/4.jpg": 4688,
	"./user/5.jpg": 9581,
	"./user/6.jpg": 354,
	"./user/7.jpg": 2063,
	"./user/8.jpg": 4316,
	"./user/9.jpg": 4841,
	"./user/profile_user.png": 3833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;